import { Component, OnInit } from '@angular/core';
import { AppService } from '../app.service';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-topics',
  templateUrl: './topics.component.html',
  styleUrls: ['../../General/tiles.css', './topics.component.css']
})
export class TopicsComponent implements OnInit {

  public language: string;
  allTopics: any[] = null;

  constructor(public appService: AppService, protected http: HttpClient) {
    this.language = this.appService.languageAbbreviation;
    if (this.appService.configuration === undefined) {
      this.loadConfigEmergency();
    }
  }

  ngOnInit() {
    this.allTopics = this.appService.getAllTopics();
  }

  /** get text in right language
  * @param {string} tag - text to load
  */
 get(tag: string): String {
   return this.appService.get(tag);
 }

  /** load a predefined configuration */
  loadConfigEmergency(): void {
    const self = this;
    const filename: string = './assets/' + this.language + '_book_config.json';

    /* ### DEMO ###
    this line is used for the demo. Uncomment it if you build a demo version

    filename = "./assets/"+this.language+"_book_config_teacher.json";*/

    this.http.get(filename).subscribe(result => {
      self.appService.configuration = result;
      self.appService.onLoadedConfig();
      self.allTopics = self.appService.getAllTopics();
    });
  }

}
